
































import { Vue, Component } from 'vue-property-decorator';
import { authorizationManagerService } from '@/services';

@Component({})
export default class CampaignSurveyResultsView extends Vue {
    private isOwnerOfCampaignIds: number[] = [];

    private beforeMount(): void {
        this.isOwnerOfCampaignIds = authorizationManagerService.isOwnerOfCampaignIds;
    }

    private mounted(): void {
        this.$root.$emit('change-active-page', 'views.surveys.campaignSurveyResultsView.campaign.' + this.$route.params.id + '.title');
    }
}
